const _appversion ="RouteMAX_2025_V5"
import * as CryptoJS  from 'crypto-js';
export function saveTokens(params) {
  localStorage.setItem("access_token", encrypt(params.access_token));
  localStorage.setItem("refresh_token", encrypt(params.refresh_token));
}

export function clearTokens() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
}

function encrypt(txt) {
  return txt ? CryptoJS.AES.encrypt(txt, _appversion).toString() : txt;
}

function decrypt(txtToDecrypt) {
  if(txtToDecrypt){
    try {
      return CryptoJS.AES.decrypt(txtToDecrypt, _appversion).toString(CryptoJS.enc.Utf8);
    } catch (e) {
      clearTokens();
    }
  }
  return null;
}

export function getAccessToken() {
  return decrypt(localStorage.getItem("access_token"));
}

export function getRefreshToken() {
  return decrypt(localStorage.getItem("refresh_token"));
}